// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__2qbyY","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__WI9Qx","Spinner":"Loader_Spinner__pqD1l","SpinnerEl":"Loader_SpinnerEl__cd_pk"};